const r = Number.isInteger || function(e) {
  return e << 0 === e;
};
export {
  r as default
};
